import { Grid } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

const TopBanner = ({ mainTopImage, propLogo }) => {
  const { href, src } = useMemo(() => {
    if (!propLogo || typeof propLogo !== "string") return { href: "", src: "" };

    const doc = new DOMParser().parseFromString(propLogo, "text/html");
    const a = doc.querySelector("a");
    const img = doc.querySelector("img");

    return {
      href: a?.getAttribute("href") || "",
      src: img?.getAttribute("src") || "",
    };
  }, [propLogo]);

  if (!href || !src) return null;

  return (
    <Grid
      container
      size={12}
      sx={{ width: "100%", height: "100px" }}
      justifyContent={"center"}
    >
      <Grid item size={12} sx={{ width: "100%" }}>
        <Link to={href ? href : ""} style={{ textDecoration: "none" }}>
          <img
            src={src ? src : mainTopImage}
            style={{
              width: "100%",
              height: "100px",
              backgroundRepeat: "no-repeat",
              objectFit: "contain", // disable this if img need to be 100% of the scree, but need wider img file.
            }}
          />
        </Link>
      </Grid>
    </Grid>
  );
};

export default TopBanner;
